import type { DonutChartLegendConfig } from '../types/pie-chart.config.js';

/**
 * Legend slot component.
 */
export const Legend = (props: DonutChartLegendConfig) => null;

Legend['displayName'] = 'DonutChart.Legend';
